module.exports = __webpack_public_path__ + "static/media/heart-outline.d3d907c5.svg";